import { DealCard } from '@dealstack/frontend/app/pages/Dashboard/DealCard';
import { GLOBAL_MEDIA_QUERIES } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling';
import { clamp } from 'lodash';
import styled from 'styled-components';
import { DealCardProps } from './DealCard.types';

interface Props {
	deals: Array<DealCardProps['deal']>;
	getDealLink: (id: string) => string;
}

export const DealCards = ({ deals, getDealLink }: Props) => {
	return (
		<DealBlocksWrapper $numberOfElements={deals.length}>
			{deals.map((deal) => (
				<DealCard key={deal.id} to={getDealLink(deal.id)} deal={deal} />
			))}
		</DealBlocksWrapper>
	);
};

const DealBlocksWrapper = styled.div<{
	$numberOfElements: number;
}>`
	display: grid;
	grid-gap: 1rem;
	grid-template-columns: 1fr;
	align-content: start;
	overflow: auto;
	width: 100%;

	@media (min-width: ${GLOBAL_MEDIA_QUERIES.llaptop}) {
		grid-template-columns: ${({ $numberOfElements }) =>
			`repeat(${clamp($numberOfElements, 1, 2)}, minmax(0, 1fr))`};
	}

	@media (min-width: 1750px) {
		grid-template-columns: ${({ $numberOfElements }) =>
			`repeat(${clamp($numberOfElements, 1, 3)}, minmax(0, 1fr))`};
	}
`;
